import mutations from "./mutation_types.js";

export default {
    [mutations.SET_INTERVALS_SETTINGS](state, settings) {
        state.intervalsSettings.saved = settings.saved
        state.intervalsSettings.intervals = [...settings.intervals]
    },

    [mutations.SET_CURRENCY](state, currency) {
        state.currency = currency
    },
    [mutations.SET_DATE](state, date) {
        state.date = date
    },
    [mutations.PUSH_TO_SELECTED](state, idsArray) {
        state.selected.push(...idsArray)
    },
    [mutations.SHIFT_FROM_SELECTED](state, id) {
        let index = state.selected.findIndex( x => x == id);
        if(index >= 0) {
            state.selected.splice(index, 1);
        }
    },
    [mutations.CLEAR_SELECTED](state) {
        state.selected = []
    }
}
